import { useCallback, useEffect, useMemo, useState } from "react";

import { resolveRedirectSource } from "./redirectSource";

export const QUERY_KEYS = {
  SOURCE: "source",
  NO_GEO: "nogeoredirection",
  DEVICE_COUNTRY: "devicecountry",
  USER_COUNTRY: "usercountry",
  BYPASS: "location",
} as const;

/**
 * Hook for managing query params related to country selector.
 */
export const useSearchParamsConfig = () => {
  const [search, setSearch] = useState("");
  const [isSearchParamLoaded, setIsSearchParamLoaded] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setSearch(window.location.search);
      setIsSearchParamLoaded(true);
    }
  }, []);

  const params = useMemo(() => new URLSearchParams(search), [search]);

  const getParam = useCallback(
    (key: string): string | null => {
      return params.get(key);
    },
    [params]
  );

  const paramsValues = useMemo(() => {
    const source = getParam(QUERY_KEYS.SOURCE);
    const noGeo = getParam(QUERY_KEYS.NO_GEO) !== null;
    const deviceCountry = getParam(QUERY_KEYS.DEVICE_COUNTRY);
    const userCountry = getParam(QUERY_KEYS.USER_COUNTRY);
    const bypass = getParam(QUERY_KEYS.BYPASS);

    return {
      source,
      noGeo,
      deviceCountry,
      userCountry,
      bypass,
      activeSource: resolveRedirectSource(source),
    };
  }, [getParam]);

  return {
    search,
    isSearchParamLoaded,
    ...paramsValues,
  };
};
